import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { createSelectors, StoreName, withDevtools } from '../config';
import { createDataSlice, DataSlice } from './slices/data';
import { createFiltersSlice, FiltersSlice } from './slices/filters';
import { createNavigationSlice, NavigationSlice } from './slices/navigation';
import { createGallerySlice, GallerySlice } from './slices/gallery';
import { createOperationsSlice, OperationsSlice } from './slices/operations';
import { createUrlCacheSlice, UrlCacheSlice } from './slices/urlCache';
import { createDownloadSlice, DownloadSlice } from './slices/download';
import { createUploadSlice, UploadSlice } from './slices/upload';
import { createOptimisticUpdatesSlice, OptimisticUpdatesSlice } from './slices/optimisticUpdates';
import { createChannelUpdatesSlice, ChannelUpdatesSlice } from './slices/channelUpdates';
import { createModuleLifecycleSlice, ModuleLifecycleSlice } from './slices/moduleLifecycle';

export type DocumentationStore = DataSlice &
  FiltersSlice &
  NavigationSlice &
  GallerySlice &
  OperationsSlice &
  UrlCacheSlice &
  DownloadSlice &
  UploadSlice &
  OptimisticUpdatesSlice &
  ChannelUpdatesSlice &
  ModuleLifecycleSlice;

// `subscribeWithSelector`: store subscribers react to selected state only
// (e.g. the displayed document) instead of every store change.
const useDocumentationStoreBase = create<DocumentationStore>()(
  withDevtools(
    subscribeWithSelector((set, get, store) => ({
      ...createDataSlice(set, get, store),
      ...createFiltersSlice(set, get, store),
      ...createNavigationSlice(set, get, store),
      ...createGallerySlice(set, get, store),
      ...createOperationsSlice(set, get, store),
      ...createUrlCacheSlice(set, get, store),
      ...createDownloadSlice(set, get, store),
      ...createUploadSlice(set, get, store),
      ...createOptimisticUpdatesSlice(set, get, store),
      ...createChannelUpdatesSlice(set, get, store),
      ...createModuleLifecycleSlice(set, get, store),
    })),
    StoreName.Documentation
  )
);

export const useDocumentationStore = createSelectors(useDocumentationStoreBase);
